import { immerable } from 'immer'
import { useState, useRef } from 'react'
import api from '@/services/api/messageGroups.js'
import titleCase from '@/utils/title-case'
import KeyHelper from '@/utils/key-helper'

class MessageGroup {

	[immerable] = true

	constructor(params) {
		this.dataElement = params.dataElement
		this.status = params.status
		this.system = params.system
		this.type = params.type
		this.on_behalf_of_id = params.on_behalf_of_id
		this.on_behalf_of_name = params.on_behalf_of_name
		this.dateFrom = params.dateFrom
		this.dateTo = params.dateTo
		this.attachments = params.attachments
	}
}

const useMessageGroups = () => {

	const [itemsData, setItems] = useState([])
	const [currentItem, setCurrentItem] = useState(null)
	const [metaData, setMeta] = useState(null)
	const [errorMsg, setErrorMsg] = useState()
	const [loading, setLoading] = useState(false)

	const lastRequestPayloadKeyRef = useRef(null)

	async function fetch(option) {
		const currentPayloadKey = KeyHelper.createKeyOfObject({ option })

		if(KeyHelper.isSameKey(lastRequestPayloadKeyRef.current, currentPayloadKey)) return;

		lastRequestPayloadKeyRef.current = currentPayloadKey

		setLoading(true)

		const [error, response] = await api.index(option)

		setLoading(false)
		if (error) {
			return setErrorMsg(error)
		}

		const { items, meta } = response
		if (!Array.isArray(items)) {
			return setErrorMsg('Messages is not an array')
		}
		const serializedData = items.map(entry => serialize(entry))
		const newItems = serializedData.map(params => new MessageGroup(params))
		setMeta(meta)
		setItems(newItems)
	}

	async function create(payload) {
		return new Promise(async (resolve, reject) => {

			const [error, response] = await api.create(payload)

			if (error) {
				return reject(error)
			}

			return resolve(response)
		})
	}

	async function exportMessage(payload) {
		return new Promise(async (resolve, reject) => {

			const [error, response] = await api.export(payload)

			if (error) {
				return reject(error)
			}

			return resolve(response)
		})
	}

	function serialize(entry) {
		return {
			status: titleCase(entry.messageStatus),
			type: entry.messageType,
			dataElement: {
				name: entry.dataElementName,
				id: entry.dataElementId,
			},
			orgId: entry.orgId,
			systemId: entry.systemId,
			dateFrom: entry.dateFrom,
			dateTo: entry.dateTo,
			on_behalf_of_id: entry.onBehalfId,
			on_behalf_of_name: entry.onBehalfName || '-NA-',
			system: {
				id: entry.orgId,
			},
			attachments: entry.attachments || [],
		}
	}

	function view(id) {
		const newCurrentItem = itemsData.find(item => item.id === id)
		setCurrentItem(newCurrentItem)
	}

	return {
		create,
		currentItem,
		error:errorMsg,
		exportMessage,
		fetch,
		items:itemsData,
		loading,
		meta:metaData,
		setCurrentItem,
		setItems,
		view,
	}

}

export default useMessageGroups
